import { j as r } from "../../../jsx-runtime-82a9ddf6.js";
const e = ({ width: o = 20, height: s = 20, className: t, style: L }) => /* @__PURE__ */ r.jsx(
  "svg",
  {
    width: o,
    height: s,
    className: t,
    style: L,
    viewBox: "0 0 24 24",
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ r.jsx("g", { children: /* @__PURE__ */ r.jsx("path", { fill: "currentColor", d: "M12,2 C6.48,2 2,6.48 2,12 C2,17.52 6.48,22 12,22 C17.52,22 22,17.52 22,12 C22,6.48 17.52,2 12,2 L12,2 Z M13,17 L11,17 L11,15 L13,15 L13,17 L13,17 Z M13,13 L11,13 L11,7 L13,7 L13,13 L13,13 Z" }) })
  }
);
export {
  e as ExclamationFilledIcon
};
